import { render, staticRenderFns } from "./SiteMaps.vue?vue&type=template&id=12dcd680&"
import script from "./SiteMaps.vue?vue&type=script&lang=js&"
export * from "./SiteMaps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports